import differenceInDays from 'date-fns/differenceInDays';
import { PRODUCT_STATUS } from '../../common/enums';

/**
 * Returns a list of product statuses based on the product's status, created date and if it's new.
 **/
export const getProductStatus = (
  status: TaxonomyTermStatus,
  statusLink: LinkProps,
  createdDate: Date,
) => {
  const todayDate = new Date();
  const publishedDate = new Date(createdDate);
  const isNew = differenceInDays(todayDate, publishedDate) <= 180;
  const newAlert = { name: PRODUCT_STATUS.NEW_PRODUCT, variant: 'success' } as TaxonomyTermStatus;

  if (status) {
    const productStatus = {
      name: status.name,
      variant: status.variant,
      link: statusLink,
    };

    // Is new and an additional status was set that isn't new product
    if (isNew && status.name !== PRODUCT_STATUS.NEW_PRODUCT) {
      return [newAlert, productStatus];
    }

    return [productStatus];
  }

  if (isNew) {
    return [newAlert];
  }

  return [];
};
